import { MacroSearchResult, MacroSearchResultType } from '../../hooks/types';

export const SEARCH_RESULT_GROUP_LABELS: Record<MacroSearchResultType, string> =
  {
    Sku: 'SKUs',
    Shipment: 'Shipments',
    Customer: 'Customers',
    CustomerContract: 'Customers',
    Supplier: 'Suppliers',
    Invoice: 'Invoices',
    Warehouse: 'Warehouses',
    Depot: 'Depots',
    Vehicle: 'Vehicles',
    NetworkTariff: 'Network tariffs',
  };

const routesByResultType: Record<
  MacroSearchResultType,
  (result: MacroSearchResult, isShipper: boolean) => string
> = {
  Sku: (result, isShipper) =>
    isShipper ? `/sku/update/${result.id}` : '/stock',
  Shipment: (result) => `/noticeboard?supplyChainProcessId=${result.id}`,
  Customer: (result) => `/customer-master/edit/${result.id}`,
  CustomerContract: (result) =>
    `/warehouse/${result.warehouseId}/manager-service-rates?matchId=${result.id}`,
  Supplier: (result) => `/supplier-master/edit/${result.id}`,
  Invoice: (result) => `/invoice/${result.id}`,
  Warehouse: (result) => `/warehouse/${result.id}`,
  Depot: (result) => `/depot/${result.id}`,
  Vehicle: (result) => `/vehicle/${result.id}`,
  NetworkTariff: (result) => `/network-ratecard/${result.id}/edit`,
};

export const canOpenSearchResultType = (type: string): boolean =>
  type in routesByResultType;

export const routeForSearchResult = (
  result: MacroSearchResult,
  isShipper: boolean
): string => routesByResultType[result.type](result, isShipper);
